<div class="alert-container">
    <h2 class="title">{{ data.title }}</h2>
    <div class="content-container">
        @if (data.description) {
            <div class="description">
                {{ data.description }}
            </div>
        }
    </div>
    <div class="buttons-container">
        <button mat-dialog-close class="btn-bordered">{{ data.dismissButtonTitle ?? 'Cancel' }}</button>
        @if (data.confirmButtonTitle) {
            <button mat-dialog-close class="btn-solid-blue btn-confirm" (click)="onConfirm.emit()">
                {{ data.confirmButtonTitle }}
            </button>
        }
    </div>
</div>
